import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ConfirmationContext = createContext(() => Promise.resolve(false));
export const useConfirmation = () => useContext(ConfirmationContext);

export default function ConfirmationProvider({ children, cancelKey }) {
  const [message, setMessage] = useState("");
  const pending = useRef(null);
  const settle = useCallback((accepted) => {
    const resolve = pending.current;
    pending.current = null;
    setMessage("");
    resolve?.(accepted);
  }, []);
  const confirm = useCallback((text) => {
    if (pending.current) return Promise.resolve(false);
    return new Promise((resolve) => {
      pending.current = resolve;
      setMessage(text);
    });
  }, []);
  useEffect(
    () => () => {
      pending.current?.(false);
      pending.current = null;
    },
    []
  );
  useEffect(() => {
    if (pending.current) settle(false);
  }, [cancelKey, settle]);
  return (
    <ConfirmationContext.Provider value={confirm}>
      {children}
      <Dialog
        open={!!message}
        onClose={() => settle(false)}
        maxWidth="xs"
        fullWidth
        aria-labelledby="confirmation-title"
        aria-describedby="confirmation-message"
      >
        <DialogTitle id="confirmation-title">Confirmar acción</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmation-message">{message}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button autoFocus variant="outlined" onClick={() => settle(false)}>
            Volver
          </Button>
          <Button variant="contained" onClick={() => settle(true)}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmationContext.Provider>
  );
}
ConfirmationProvider.propTypes = {
  children: PropTypes.node.isRequired,
  cancelKey: PropTypes.string,
};
